import { useState, useCallback } from "react";
import { fetchContacts, createContact, updateContact, deleteContact } from "../api/contactsApi";

export function useContacts() {
  const [data, setData] = useState({ contacts: [], meta: null });
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async (params) => {
    setLoading(true);
    try {
      const result = await fetchContacts(params);
      setData(result);
    } catch (err) {
      console.error("Failed to fetch contacts", err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, fetch };
}

export function useCreateContact() {
  const [isPending, setIsPending] = useState(false);

  const mutate = async (payload) => {
    setIsPending(true);
    try {
      return await createContact(payload);
    } finally {
      setIsPending(false);
    }
  };

  return { mutate, isPending };
}

export function useUpdateContact() {
  const [isPending, setIsPending] = useState(false);

  const mutate = async (id, payload) => {
    setIsPending(true);
    try {
      return await updateContact(id, payload);
    } finally {
      setIsPending(false);
    }
  };

  return { mutate, isPending };
}

export function useDeleteContact() {
  const [isPending, setIsPending] = useState(false);

  const mutate = async (id) => {
    setIsPending(true);
    try {
      return await deleteContact(id);
    } finally {
      setIsPending(false);
    }
  };

  return { mutate, isPending };
}
